
    import FormatterService from "@/service/FormatterService";


    export default {
        name: 'ShareSplits',

        props: {
            share: Object
        },

        created() {
            this.format = new FormatterService()
        },
    }
